import { IStateManager, CaptureState, CapturedImages } from './interfaces/IStateManager';
import { IEventBus } from './interfaces/IEventBus';

export class StateManagerService implements IStateManager {
  private captureState: CaptureState = {
    step: 'front',
    isCapturing: false,
    isDetectionPaused: false,
    isVideoActive: false,
    isLoading: false,
    showFlipAnimation: false,
    showSuccessAnimation: false,
    bestScore: 0,
    hasScreenshotTaken: false
  };

  private capturedImages: CapturedImages = {
    front: {
      fullFrame: null,
      cropped: null
    },
    back: {
      fullFrame: null,
      cropped: null
    },
    metadata: {
      totalImages: 0,
      processCompleted: false,
      backCaptureSkipped: false
    }
  };

  constructor(private eventBus: IEventBus) {}

  getCaptureState(): CaptureState {
    return { ...this.captureState };
  }

  updateCaptureState(updates: Partial<CaptureState>): void {
    const previousState = { ...this.captureState };
    this.captureState = { ...this.captureState, ...updates };
    
    // Emit state change event
    this.eventBus.emit('state-changed', {
      previous: previousState,
      current: this.captureState,
      changes: updates
    });
  }

  getCapturedImages(): CapturedImages {
    return JSON.parse(JSON.stringify(this.capturedImages));
  }

  setCapturedImages(images: Partial<CapturedImages>): void {
    this.capturedImages = {
      ...this.capturedImages,
      ...images,
      metadata: {
        ...this.capturedImages.metadata,
        ...images.metadata
      }
    };

    // Update total images count
    let totalImages = 0;
    if (this.capturedImages.front.fullFrame && this.capturedImages.front.cropped) {
      totalImages += 2;
    }
    if (this.capturedImages.back.fullFrame && this.capturedImages.back.cropped) {
      totalImages += 2;
    }
    this.capturedImages.metadata.totalImages = totalImages;
  }

  reset(): void {
    this.captureState = {
      step: 'front',
      isCapturing: false,
      isDetectionPaused: false,
      isVideoActive: false,
      isLoading: false,
      showFlipAnimation: false,
      showSuccessAnimation: false,
      bestScore: 0,
      hasScreenshotTaken: false
    };

    this.capturedImages = {
      front: {
        fullFrame: null,
        cropped: null
      },
      back: {
        fullFrame: null,
        cropped: null
      },
      metadata: {
        totalImages: 0,
        processCompleted: false,
        backCaptureSkipped: false
      }
    };

    this.eventBus.emit('state-changed', {
      previous: null,
      current: this.captureState,
      changes: { reset: true }
    });
  }

  isProcessCompleted(): boolean {
    return this.captureState.step === 'completed';
  }

  canProceedToBack(): boolean {
    return this.captureState.step === 'front' && 
           this.capturedImages.front.fullFrame !== null && 
           this.capturedImages.front.cropped !== null;
  }
}